module.exports = __webpack_public_path__ + "assets/link-blue.eda5d2fa.svg";